/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_TitleInputs */

const en_guide_json_schema_s2_title = /** @type {(inputs: Guide_Json_Schema_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core Keywords`)
};

const ko_guide_json_schema_s2_title = /** @type {(inputs: Guide_Json_Schema_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핵심 키워드`)
};

const ja_guide_json_schema_s2_title = /** @type {(inputs: Guide_Json_Schema_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コアキーワード`)
};

/**
* | output |
* | --- |
* | "Core Keywords" |
*
* @param {Guide_Json_Schema_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_title = /** @type {((inputs?: Guide_Json_Schema_S2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_title(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_title(inputs)
	return ja_guide_json_schema_s2_title(inputs)
});